import type {Component} from 'grapesjs';
import type {FormMakerFontSize} from '@FormMakerReact/lib/form-maker-typography';

/** CSS property the font-size control reads / writes on the selected component. */
export const FONT_SIZE_PROPERTY = 'font-size';

export interface FontSizeOption {
  label: string;
  value: FormMakerFontSize;
}

export interface FontSizeControlProps {
  component: Component;
  sizes: readonly FontSizeOption[];
}

export interface SizeButtonRenderArgs {
  size: FontSizeOption;
  isActive: boolean;
  onSelect: () => void;
}
